"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavButtons = require("./NavButtons.css");

var _NavButtons2 = _interopRequireDefault(_NavButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

//     

var NavButtons = function NavButtons(props) {
	return _react2.default.createElement(
		_semanticUiReact.Button.Group,
		{ className: _NavButtons2.default.myNavButtons },
		_react2.default.createElement(_semanticUiReact.Button, { basic: true, color: "teal", disabled: props.disabledPrev, floated: "left", labelPosition: "left", icon: "left chevron", content: "Anterior", onClick: props.goPrevStep }),
		_react2.default.createElement(_semanticUiReact.Button, { color: "teal", disabled: props.disabledNext, floated: "right", labelPosition: "right", icon: "right chevron", content: "Seg\xFCent", onClick: props.goNextStep })
	);
};

//import * as CONSTANTS from "../../utils/constants";
exports.default = NavButtons;


NavButtons.propTypes = {
	goPrevStep: _propTypes2.default.func,
	goNextStep: _propTypes2.default.func,
	disabledPrev: _propTypes2.default.bool,
	disabledNext: _propTypes2.default.bool
};
